<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Add comment
      @if (!loading && person) {
        <p class="subtitle">
          @if (person.full_name) {
            <span>{{person.full_name}} (#{{person.number}})</span>
          }
          @if (!person.full_name) {
            <span>#{{person.number}}</span>
          }
        </p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="add()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-textarea #comment_input type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" label="Comment" labelPlacement="stacked" fill="outline" [(ngModel)]="comment"></ion-textarea>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>